import HomePage from './HomePage';
import { useParams } from 'react-router';

const PlusCodeRedirect = () => {
  const params = useParams();
  const plusCode = params['plusCode'] || params['*'];

  return <HomePage plusCode={plusCode} />;
};

export default PlusCodeRedirect;
